import * as React from 'react';
import { pieArcLabelClasses, PieChart } from '@mui/x-charts/PieChart';
import { Box } from '@mui/material';

const convertStatusCodeDataForChart = (statusData) => {
    if (!statusData || typeof statusData !== 'object') return [];

    return Object.entries(statusData).map(([code, value], index) => ({
        id: index,
        value: value?.count || 0,
        label: `Status ${code}`,
    }));
};

export default function StatusCodePieChart({ data }) {
    const chartData = convertStatusCodeDataForChart(data);

    const size = {
        width: 400,
        height: 450,
    };

    if (!chartData.length) {
        return <Box sx={{ textAlign: 'center', mt: 4 }}>No API call data available</Box>;
    }


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <PieChart
                series={[
                    {
                        data: chartData,
                        arcLabel: (item) => `${item.label}: ${item.value}`,
                        arcLabelMinAngle: 10,
                        arcLabelRadius: '60%',
                    },
                ]}
                slotProps={{
                    legend: {
                        direction: 'row',
                        position: { vertical: 'bottom', horizontal: 'center' },
                    },
                }}
                sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                        fontWeight: 'bold',
                    },
                    mt: 3,
                    mb: 2,
                }}
                {...size}
            />
        </Box>
    );
}
